import React from 'react';
import { theme } from '../../config/theme';

const Chevron = ({ open }) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={theme.colors.primary}
        strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
        style={{ marginLeft: 'auto', flexShrink: 0, transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'none' }}>
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const toggleStyle = {
    flex: '1 1 auto',
    minHeight: '40px',
    padding: 0,
    border: 'none',
    background: 'none',
    font: 'inherit',
    color: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
};

/**
 * Encabezado de una sección plegable en el celular (ver useMobileCollapse).
 * En escritorio renderiza el mismo contenido en un div, sin cambios visuales.
 */
const CollapsibleHeader = ({ isMobile, isOpen, onToggle, style, children }) => {
    if (!isMobile) return <div style={style}>{children}</div>;
    return (
        <button type="button" onClick={onToggle} aria-expanded={isOpen} style={{ ...toggleStyle, ...style }}>
            {children}
            <Chevron open={isOpen} />
        </button>
    );
};

export default CollapsibleHeader;
